import React, { useMemo } from 'react';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import EventOccurCountInputItem from './components/EventOccurCountInputItem';
import './index.scss';

interface IEventOccurCountInputProps {
  minValue?: string;
  maxValue?: string;
  onMinChange: (val: string) => void;
  onMaxChange: (val: string) => void;
  placeholder: string;
}

const EventOccurCountInput: React.FC<IEventOccurCountInputProps> = ({
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  placeholder,
}) => {
  const { getLocalText } = useLocal('filter');

  const minError = useMemo(() => {
    if (minValue && !Number.isInteger(Number(minValue))) {
      return getLocalText('event_occur_count_integer_error');
    }
    return '';
  }, [minValue, getLocalText]);

  const maxError = useMemo(() => {
    if (maxValue && !Number.isInteger(Number(maxValue))) {
      return getLocalText('event_occur_count_integer_error');
    }
    const minVal = parseFloat(minValue || '0');
    const maxVal = parseFloat(maxValue || '');
    if (maxValue && !isNaN(minVal) && !isNaN(maxVal) && maxVal < minVal) {
      return getLocalText('event_occur_count_range_error');
    }
    return '';
  }, [minValue, maxValue, getLocalText]);

  return (
    <div className="dbd-event-filter-content__occur-count-wrapper">
      <div className="dbd-event-filter-content__occur-count-range">
        <EventOccurCountInputItem
          value={minValue}
          onChange={onMinChange}
          placeholder={placeholder}
          error={minError}
        />
        <span className="dbd-event-filter-content__occur-count-separator">~</span>
        <EventOccurCountInputItem
          value={maxValue}
          onChange={onMaxChange}
          placeholder={placeholder}
          error={maxError}
        />
      </div>
    </div>
  );
};

export default EventOccurCountInput;

